export default [
    {
        name: 'terms',
        label: 'Terms & Conditions',
        params: { id: 16 },
    },
    {
        name: 'privacy',
        label: 'Privacy Policy',
        params: { id: 18 },
    },
    {
        name: 'help',
        label: 'Help',
        params: { id: 17 },
    }
]



// WEBPACK FOOTER //
// ./src/config/links.js